import { HTTP, authHeader } from './http-service';

class BrandmisuseIntelService {
  get(payload) {
    return HTTP.get(`/DisputesBrandMisuseIntel/${payload.disputeId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  updateTradingStandards(payload) {
    return HTTP.put(`/DisputesBrandMisuseIntel/${payload.disputeId}/tradingstandards`, payload.tradingStandards, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  search(payload) {
    return HTTP.post(`/DisputesBrandMisuseIntelSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new BrandmisuseIntelService();
